export const IndyOrderArray = [];


export function getSingleOrderArray(){

    let orderArray = [];
    orderArray.push(getSingleOrderObject())

    return orderArray;
}

export function getSingleOrderObject(){

    let IndyOrder = {

        //fa handleOrderDetailsDropDownChanges={ props.handleOrderDetailsDropDownChangesOrderTwo }
        //   handleTextInputChange={ props.handleTextInputChange }
        shirtColor: '',
        shirtSize: '',
        shirtType: '',
        qty: '',
        qtyTextFeildName: '',
        topDividerText: '',
        visible: '',
        // handleAddMoreClick: '',
        formErrorFieldArray: '',
        order2Visible: '',
        order3Visible: '',
        itemSelected: '',
        jerseyNumberFieldName: '',
        jerseyNameFieldName: '',
        jerseyNumber: '',
        jerseyName: '',
        //FOOTBACLL
        teamSelection: '',
        selectedTeamColors: '',
        shirtColors: '',
        typedInTeamNameFieldName: '',
        typedInTeamName: '',
        shirtSizes: '',
        childsAgeTextFeildName: ''
    }

    return IndyOrder;
}


// WEBPACK FOOTER //
// ./src/config/SingleOrderUtils.js